const GAMES =['match3', 'docker'];
export default GAMES;
